export const generatedRuntimeValidationCampaignLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-runtime-validation-campaign-ledger",
  "operatingRule": "Runtime validation campaigns are execution governance records. They do not promote science claims; they define exact runtime artifacts, residual checks, scenario deltas, and review gates needed before claims can move.",
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "campaignCount": 6,
  "blockedCampaignCount": 4,
  "statusCounts": {
    "runtime-promoted-currently-reproducible": 2,
    "blocked-runtime-prerequisites": 4
  },
  "evidenceHashes": {
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
  },
  "campaigns": [
    {
      "id": "campaign-spice-contact-windows",
      "title": "SPICE contact and solar-interference windows",
      "priorityLane": "P0-critical-path",
      "contractIds": [
        "spice-gf-event-window-v1"
      ],
      "scenarioIds": [
        "mercury-orbit",
        "hybrid",
        "moon-first"
      ],
      "customerQuestion": "Can conjunction, occultation, and contact-window assumptions be regenerated from reviewed SPICE kernels in the current runtime environment?",
      "decisionImpact": "Reduces communications/autonomy uncertainty only after current-shell reproducibility and kernel-custody proof pass.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "runtime-promoted-currently-reproducible",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "spice-gf-event-window-v1",
          "tool": "NASA NAIF SPICE Geometry Finder",
          "readinessState": "runtime-artifact-promoted",
          "reproducibilityState": "promoted-artifact-currently-reproducible",
          "latestPreflightCanReproduce": true,
          "bestPreflightCanReproduce": true,
          "promotedArtifactHash": "sha256-6bba7e3d4ceef9f865c3cf9acee8fe83bd68bf0d803fafb7b852530cffcad8f0",
          "readinessHash": "sha256-a30df59ba18a6787ab37d68842db0d846b284c3c00af038b144fe3a2027ff6d3"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "spice-gf-event-window-v1",
          "workOrderId": "work-order-spice-gf-event-window-v1",
          "workOrderHash": "sha256-28129dc4f5b602e71d08f8d395f99a34f947b41c576c5b070c8a2c010456ce42",
          "runSpecId": "run-spec-spice-gf-event-window-v1",
          "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c",
          "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
          "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "SPICE kernel coverage, TDB/ET time key, confinement window, GF constraint, and event-window endpoints are recorded."
          ]
        }
      ],
      "linkedEvidenceGap": null,
      "blockers": [],
      "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-462420fcd20cbc0ba392b0abb149494b622e04cfd25b622c7e86c32a8f797fc3"
    },
    {
      "id": "campaign-orekit-propagation",
      "title": "Orekit propagation and event checks",
      "priorityLane": "P0-critical-path",
      "contractIds": [
        "orekit-propagation-v1"
      ],
      "scenarioIds": [
        "hybrid",
        "moon-first",
        "mercury-orbit"
      ],
      "customerQuestion": "Can the mission-design propagation assumptions survive a documented Orekit force model, frame, and time-scale run?",
      "decisionImpact": "Provides the first independent trajectory propagation artifact needed to lower mission-design uncertainty.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "blocked-runtime-prerequisites",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "orekit-propagation-v1",
          "tool": "Orekit",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "orekit-propagation-v1",
          "workOrderId": "work-order-orekit-propagation-v1",
          "workOrderHash": "sha256-69e531fee46ffac8b1b6865c5bc3cc5248c7b3d18f193615a03cd44aedd404b7",
          "runSpecId": "run-spec-orekit-propagation-v1",
          "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
          "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
          "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        }
      ],
      "linkedEvidenceGap": {
        "id": "experiment-01-gap-runtime-orekit-propagation-v1",
        "priorityScore": 78,
        "experimentHash": "sha256-2b3b43263ea3d54353e5cce4ed1797cbf0fde1e8899e70559b44131d761f551d",
        "currentState": "experiment-planned-blocked-until-evidence"
      },
      "blockers": [
        "Missing command/runtime: Java",
        "Missing path or env input: OREKIT_DATA_PATH",
        "Missing path or env input: OREKIT_SIDECAR_JAR",
        "Runtime artifact not promoted."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-34e5be85925dbc6bf6a3acb190d67f8c3d409469f12f69f7ca321872ac2e6a33"
    },
    {
      "id": "campaign-gmat-transfer",
      "title": "GMAT transfer and constraint residuals",
      "priorityLane": "P0-critical-path",
      "contractIds": [
        "gmat-transfer-v1"
      ],
      "scenarioIds": [
        "hybrid",
        "moon-first",
        "mercury-orbit"
      ],
      "customerQuestion": "Can transfer constraints and optimizer outputs be reproduced from a hashed GMAT script and compared against Orekit/Tudat?",
      "decisionImpact": "Turns mission-design claims from scaffolded assumptions into cross-checkable transfer evidence once residuals pass.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "blocked-runtime-prerequisites",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "gmat-transfer-v1",
          "tool": "NASA GMAT",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "gmat-transfer-v1",
          "workOrderId": "work-order-gmat-transfer-v1",
          "workOrderHash": "sha256-fe29e92d043ca958978f5f4495f54e42bb1b84cdf0965ca5db25f5e77b1f0b8d",
          "runSpecId": "run-spec-gmat-transfer-v1",
          "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
          "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
          "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        }
      ],
      "linkedEvidenceGap": {
        "id": "experiment-02-gap-runtime-gmat-transfer-v1",
        "priorityScore": 77,
        "experimentHash": "sha256-1f2a9b1e8259fc195f0ca63dafe80764be5835aca882c588e05bddecd2415403",
        "currentState": "experiment-planned-blocked-until-evidence"
      },
      "blockers": [
        "Missing command/runtime: GMAT",
        "Runtime artifact not promoted."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-c53e6e950ae8a2f0c08b1e20e266a4cedbcd3a50650849182257416abec9feb2"
    },
    {
      "id": "campaign-tudat-cross-check",
      "title": "Tudat third-tool trajectory cross-check",
      "priorityLane": "P0-critical-path",
      "contractIds": [
        "tudat-transfer-v1"
      ],
      "scenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "customerQuestion": "Can a third astrodynamics implementation bound disagreement for asteroid and hybrid transfer assumptions?",
      "decisionImpact": "Prevents a single-tool trajectory result from becoming overconfident before disagreement bounds are visible.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "blocked-runtime-prerequisites",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "tudat-transfer-v1",
          "tool": "Tudat",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "tudat-transfer-v1",
          "workOrderId": "work-order-tudat-transfer-v1",
          "workOrderHash": "sha256-762279e25442533a1eb05a89ea533c13c672334e6f1bc44279885dc56a2d8ff8",
          "runSpecId": "run-spec-tudat-transfer-v1",
          "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
          "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
          "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        }
      ],
      "linkedEvidenceGap": {
        "id": "experiment-03-gap-runtime-tudat-transfer-v1",
        "priorityScore": 77,
        "experimentHash": "sha256-a0db28faf34bc01b47e6af539f8df61412fca5bc77e5be23fb978c079b24cd8b",
        "currentState": "experiment-planned-blocked-until-evidence"
      },
      "blockers": [
        "Missing Python module: tudatpy",
        "Runtime artifact not promoted."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-acf23215d3bb46936335c11ff99cc341490a625810d4895ab6894955cf54ab38"
    },
    {
      "id": "campaign-cross-tool-residual-frontier",
      "title": "Cross-tool residual frontier",
      "priorityLane": "P0-critical-path",
      "contractIds": [
        "orekit-propagation-v1",
        "gmat-transfer-v1",
        "tudat-transfer-v1"
      ],
      "scenarioIds": [
        "hybrid",
        "mercury-orbit",
        "asteroid-first"
      ],
      "customerQuestion": "Where do Orekit, GMAT, and Tudat disagree enough to change scenario rank, uncertainty band, or blocker count?",
      "decisionImpact": "Defines the required residual frontier before trajectory evidence can support customer-facing rankings.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "blocked-runtime-prerequisites",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "orekit-propagation-v1",
          "tool": "Orekit",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
        },
        {
          "contractId": "gmat-transfer-v1",
          "tool": "NASA GMAT",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf"
        },
        {
          "contractId": "tudat-transfer-v1",
          "tool": "Tudat",
          "readinessState": "blocked-runtime-prerequisites",
          "reproducibilityState": "no-promoted-artifact-runtime-blocked",
          "latestPreflightCanReproduce": false,
          "bestPreflightCanReproduce": false,
          "promotedArtifactHash": null,
          "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        },
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "orekit-propagation-v1",
          "workOrderId": "work-order-orekit-propagation-v1",
          "workOrderHash": "sha256-69e531fee46ffac8b1b6865c5bc3cc5248c7b3d18f193615a03cd44aedd404b7",
          "runSpecId": "run-spec-orekit-propagation-v1",
          "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
          "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
          "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        },
        {
          "contractId": "gmat-transfer-v1",
          "workOrderId": "work-order-gmat-transfer-v1",
          "workOrderHash": "sha256-fe29e92d043ca958978f5f4495f54e42bb1b84cdf0965ca5db25f5e77b1f0b8d",
          "runSpecId": "run-spec-gmat-transfer-v1",
          "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
          "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
          "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        },
        {
          "contractId": "tudat-transfer-v1",
          "workOrderId": "work-order-tudat-transfer-v1",
          "workOrderHash": "sha256-762279e25442533a1eb05a89ea533c13c672334e6f1bc44279885dc56a2d8ff8",
          "runSpecId": "run-spec-tudat-transfer-v1",
          "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
          "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
          "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        }
      ],
      "linkedEvidenceGap": {
        "id": "experiment-01-gap-runtime-orekit-propagation-v1",
        "priorityScore": 78,
        "experimentHash": "sha256-2b3b43263ea3d54353e5cce4ed1797cbf0fde1e8899e70559b44131d761f551d",
        "currentState": "experiment-planned-blocked-until-evidence"
      },
      "blockers": [
        "Missing command/runtime: Java",
        "Missing path or env input: OREKIT_DATA_PATH",
        "Missing path or env input: OREKIT_SIDECAR_JAR",
        "Runtime artifact not promoted.",
        "Missing command/runtime: GMAT",
        "Missing Python module: tudatpy"
      ],
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
    },
    {
      "id": "campaign-openmdao-dymos-sensitivity",
      "title": "OpenMDAO/Dymos logistics sensitivity replay",
      "priorityLane": "P1-business-grade",
      "contractIds": [
        "openmdao-dymos-optimization-v1"
      ],
      "scenarioIds": [
        "moon-first",
        "hybrid"
      ],
      "customerQuestion": "Can logistics sensitivity and objective/constraint changes be replayed without hiding assumptions?",
      "decisionImpact": "Keeps optimization output useful as sensitivity evidence while blocking it from becoming a recommendation by itself.",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "campaignStatus": "runtime-promoted-currently-reproducible",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "contractStates": [
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "tool": "OpenMDAO/Dymos",
          "readinessState": "runtime-artifact-promoted",
          "reproducibilityState": "promoted-artifact-currently-reproducible",
          "latestPreflightCanReproduce": true,
          "bestPreflightCanReproduce": true,
          "promotedArtifactHash": "sha256-4ae76fa49e39336042cd1e76f36873c538a5a60e80e5194289d5a1daf909b896",
          "readinessHash": "sha256-6c97cc882c1df4c7705d2dda567cd773d0dbf2397ade5edbb0514b9aaaebb1d5"
        }
      ],
      "scenarioRefs": [
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        }
      ],
      "workOrderRefs": [
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "workOrderId": "work-order-openmdao-dymos-optimization-v1",
          "workOrderHash": "sha256-1ce46385d38db2f60463bcece1fffd0384f58b63d8f7c30ca9c777ac046ece55",
          "runSpecId": "run-spec-openmdao-dymos-optimization-v1",
          "runSpecHash": "sha256-282d8d68479110e12375b4ee39ea99c50bc9b58767b28570ab5c3c5b7a92caa0",
          "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
          "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
          "acceptanceGates": [
            "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
            "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
            "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
            "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
            "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
          ]
        }
      ],
      "linkedEvidenceGap": null,
      "blockers": [],
      "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
      "acceptanceRule": "A campaign can influence scenario decisions only after every required sidecar artifact is runtime-generated, intake-validated, reviewed, and linked to before/after scenario decision deltas.",
      "campaignHash": "sha256-28ead518f55addb23e76eb96ca9c3f8a3bf0d9da09ffb6c1bb636e4c02f372b0"
    }
  ],
  "ledgerHash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
  "markdownPath": "public/runtime-validation-campaign-ledger.md",
  "markdownHash": "sha256-78ebc5b25ce76517cfa83cb3360483ef3ed27d74de470d512389b234981cb2ea"
}
;
